module.exports = __webpack_public_path__ + "static/media/videoLogin.60407eac.mov";